// @see https://www.beyondtheboxscore.com/2012/10/10/3481462/mlb-strikeouts-analysis-sabermetrics-whiffs
const SwingDecision = {
    Swing: { key: 'Swing', name: 'Swing', type: 'STRING', description: 'Number of pitches at which batter swung.' },
    Contact: { key: 'Contact', name: 'Contact', type: 'STRING', description: 'Number of pitches classified as swinging strike.' },
    Whiff: { key: 'Whiff', name: 'Whiff', type: 'STRING', description: 'Number of pitches at which batter made an contact with baseball.' },
    Unclassified: { key: 'Unclassified', name: 'Unclassified' },
};

export default SwingDecision;